// extracted by mini-css-extract-plugin
export default {"perksSection":"Perks_perksSection__xxKPE","container":"Perks_container__PE3vd","perksGrid":"Perks_perksGrid__jigBn","perkCard":"Perks_perkCard__ZtTzK"};